module.exports = __webpack_public_path__ + "static/media/casters.22cdcfdd.svg";